import MySelect from './Select';

export default MySelect;
